var moment = require('moment')

var sex = (val) => {
    if (val == 0) return "男";
    if (val == 1) return "女";
    return "";
};
var date = (date) => {
    return date && moment(date).format("YYYY-MM-DD")
};
var day = (date) => {
    return date && moment(date).format("DD")
};
var age = (date) => {
    return moment().diff(date, 'years')
};
var month = (date) => {
    return date && moment(date).month() + 1;
};
var yearMonth = (date) => {
    return date && moment(date).format("YYYY-MM")
};
var Newline = (str) => {
    if(str){
        return str.replace(/[\r\n]/g,"<br/>");
    }else{
        return '';
    }
};
var money = m=>{
    (m+"").replace(/./g, function(c, i, a) {
        return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c;
    });
    return m;
};
var abs = m=>{
    return Math.abs(m);
};
var moneyFormat = m=>{
    return Number(m).toFixed(2)
}
var tel = phone=>`tel:${phone}`;

export {
    Newline,
    sex,
    date,
    day,
    age,
    month,
    yearMonth,
    money,
    tel,
    abs,
    moneyFormat
}


// WEBPACK FOOTER //
// ./src/common/js/filters.js